import { extendTheme } from '@chakra-ui/react'

const theme = extendTheme({
    fonts: {
        body: 'Josefin Sans',
    },
})

export default theme